module.exports = __webpack_public_path__ + "img/main_dlw.71de4324.jpg";